<mat-form-field appearance="outline" [hideRequiredMarker]="true" [formGroup]="group">
  <mat-label>{{ placeholder }}</mat-label>
  <input matInput
    id="{{ idx }}"
    formControlName="{{ controlName }}"
    maxlength="{{ maxlength }}"
    [attr.aria-pressed]=""
    type="{{ type }}"
    [attr.autocomplete]="autocomplete"
    [textMask]="{ mask: mask, guide: false, keepCharPositions: true, modelClean: true }">
  <mat-icon *ngIf="suffix" matSuffix>{{ suffix }}</mat-icon>
  <mat-hint>{{ content.hint }} <span class="mat_hit_hidden"  *ngIf="required">required</span></mat-hint>
  <mat-error *ngIf="group.controls[controlName].invalid" [attr.aria-label]="'Error '+content.hint + validationMessage.get(group.controls[controlName], placeholder) ">Error: {{ content.hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
</mat-form-field>